var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn-square",attrs:{"disabled":_vm.loading,"variant":_vm.variant},on:{"click":_vm.click}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "+_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }